export default __webpack_public_path__ + "static/media/CL14.63cbd1ba.mp3";